export default "__VITE_ASSET__ChqMeXbr__"